import React, {useState} from 'react';
import {connect} from 'react-redux';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import {Checkbox, useMediaQuery, useTheme} from "@material-ui/core";
import css from './Layers.module.css';
import './Layers.css';
import PokemonControls from "./PokemonControls";
import {toggleFeature} from "../../../../store/filterSlice";
import {fetchData, Page, setShowFilters} from "../../../../store/coreSlice";
import TabPanel from "./TabPanel";
import GymControls from "./GymControls";
import RaidControls from "./RaidControls";
import StopControls from "./StopControls";
import SavePreset from "./SavePreset";

const mainLayers = [
	{num: 0, id: 'showPokemon', name: 'Spawns', elt: <PokemonControls/>},
	{num: 1, id: 'showRaids', name: 'Raids', elt: <RaidControls/>},
	{num: 2, id: 'showGyms', name: 'Gyms', elt: <GymControls/>},
	{num: 3, id: 'showStops', name: 'Stops', elt: <StopControls/>},
];

const getInitialTab = (filters) => {
	for( let i=0; i<mainLayers.length; i++ )
		if( filters[mainLayers[i].id] )
			return i;

	return 0;
};

const Layers = (props) => {
	const [tab, setTab] = useState(getInitialTab(props.filters));
	const [savingPreset, setSavingPreset] = useState(false);
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

	const handleClose = () => {
		props.setShowFilters(false);
	};

	const onClickToggleLayer = (event, layer) => {
		props.toggleFeature(layer);
	};

	const handleTabChange = (event, newValue) => {
		setTab(newValue);
	};

	const onCloseSavePreset = (shouldClose=false) => {
		setSavingPreset(false);
		if( shouldClose )
			handleClose();
	};

	if( savingPreset ) {
		return <SavePreset onClose={onCloseSavePreset} />;
	}


	let content = null;
	let title = 'Map Layers';
	if( props.page === Page.S2 ) {
		title = 'S2 Map';
		content = (<div className={css.S2Blurb}>
			<p>The S2 view helps find the best places to submit portal nominations. The small cells with black
				outlines are level 17 S2 cells. There can only be one PokéStop or gym per cell, so you should only
				add submissions to empty cells. If a cell has a grey background, there's already a portal in it.
				If there's a yellow background, someone has submitted a nomination in that cell. If you nominate a
				PokéStop, you can click the empty cell to notify others that you've got a pending submission, to
				avoid duplicates.</p>

			<p>Each portal is represented by a dot - blue for stops, red for gyms, and grey for portals in Ingress
				that aren't in PoGo (but still apply). The halo around it is a 20 meter
				radius. New portals can't be within 20m of existing ones, so you need to stay outside of the range
				of existing portals. For precise positioning, switch on the satellite view for the map, which will
				correspond to the in-game view.</p>

			<p>The larger green cells (level 14) determine where gyms will pop up. If a second portal is added to a
				green cell, a gym will form in the original portal. The same goes for the 6th and 20th portal per
				cell. When you zoom out, you'll see a portal count for each green cell to tell you how close it is to
				hatching a new gym.</p>
		</div>);
	} else if( props.page === Page.NESTS ) {
		title = 'Nests';
		content = (<div className={css.NestsBlurb}>
			<p>This is a map of the current nests. It updates automatically every two weeks when nests migrate.
				You can view a list from the <a href='https://www.a2pogo.com/'>main site</a>. </p>
		</div>);
	} else {
		content = (<div id="alert-dialog-description">
			<div  className={fullScreen ? css.TabContainerMobile : css.TabContainerDesktop}>
				<Tabs
					orientation={fullScreen ? "horizontal" : "vertical"}
					variant="scrollable"
					value={tab}
					onChange={handleTabChange}
					className={css.Tabs}
				>
					{mainLayers.map(layer => {
						return <Tab key={'tab-' + layer.id} className={css.Tab} id={layer.id}
									label={(<div className={css.TabDiv}>
										<Checkbox className={css.Checkbox} checked={props.filters[layer.id]} onChange={(event) => onClickToggleLayer(event, layer.id)} />
										{layer.name}
									</div>)}  />;
					})}
				</Tabs>

				{mainLayers.map(layer => {
					return (<TabPanel key={'tabpanel-' + layer.id} className={css.TabPanels} value={tab} index={layer.num}>
						{layer.elt}
					</TabPanel>);
				})}

			</div>
		</div>);
	}

	return (<Dialog
		fullScreen={fullScreen}
		className={css.Layers + ' Settings'}
		open={props.showFilters}
		onClose={handleClose}
		maxWidth='sm'
		fullWidth={true}
	>
		<DialogTitle id="alert-dialog-title">{title}</DialogTitle>
		<DialogContent className='FilterTabs'>
			{content}
		</DialogContent>
		<DialogActions className={fullScreen && css.DialogActions}>
			{props.page === Page.LIVE &&
			<Button onClick={() => setSavingPreset(true)} color="primary" autoFocus>
				Save Preset
			</Button>
			}
			<Button onClick={handleClose} color="primary" autoFocus>
				Close
			</Button>
		</DialogActions>
	</Dialog>);
};

const mapStateToProps = (state) => {
	return {
		// NAME: state.NAME
		filters: state.filter,
		showFilters: state.core.showFilters,
		page: state.core.page,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		toggleFeature: (id) => dispatch(toggleFeature(id)),
		setShowFilters: (val) => dispatch(setShowFilters(val)),
		fetchData: (val) => dispatch(fetchData(val))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Layers);